import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { isAllRaterClosed } from '../../utils/calculations';
import AverageOfRatesOfObjective from './AverageOfRatesOfObjective';
import CriteriaEvaluationsGroupedByEmployees from './CriteriaEvaluationsGroupedByEmployees';
import { STATUS } from '../../utils/const';
import { HourglassFullRounded } from '@material-ui/icons';

const useStyles = makeStyles({
  root: {
    minWidth: '531px'
  },
  title: {
    color: '#999999',
    fontSize: '16px',
    textTransform: 'uppercase'
  },
  baseText: {
    fontSize: '16px',
    marginBottom: '10px',
    maxWidth: '531px',
    whiteSpace: 'pre-wrap'
  },
  infoBox: {
    margin: '5px'
  },
  icon: {
    color: '#C69060'
  },
  appraiserName: {
    marginLeft: '8px'
  },
  appraisersWrapper: {
    display: 'flex',
    alignItems: 'baseline'
  }
}, { name: 'ObjectiveInfo' });

const ObjectiveInfo = ({
  objective, objectiveRates, averageOfObjectiveRates, isPanelOpened, onSubmitSuccess
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const getApprasiersOfObjective = objective => {
    const {
      appraisers_and_criterias: {
        appraisers
      },
      approvals,
      status
    } = objective || {};

    const approvalIds = approvals.map(({ employee_id }) => employee_id);

    if (status === STATUS.PROPOSED) {
      const renderNames = appraisers => {
        const displayName =  appraisers.map(({ employee_id , name }, index) => {
          return approvalIds.includes(employee_id) ?
            <Tooltip key={ employee_id } placement='top'
              title={
                <Typography variant='body2'>
                  {t('objective.alert.acceptWarning')}
                </Typography>
              }>
              <Box display='flex' alignItems='end'>
                <Typography variant='body2'
                  display='initial'
                  className={ index !== 0 && classes.appraiserName }
                >
                  { name }
                </Typography>
                <HourglassFullRounded className={ classes.icon }/>
                { index < appraisers.length - 1 && ','}
              </Box>
            </Tooltip> :
            <Typography
              key={ employee_id }
              variant='body2'
              className={ index !== 0 && classes.appraiserName }
            >
              { name }
              { index < appraisers.length - 1 && ','}
            </Typography>;
        });
        return displayName;
      };

      return (
        <div className={ classes.appraisersWrapper }>
          {renderNames(appraisers)}
        </div>
      );
    } else {
      return appraisers.map(({ name }) => name).join(', ');
    }
  };

  return (isPanelOpened ?
    <Grid container direction='column'>
      <Typography className={ classes.title } component='div'>
        {t('objective.description')}
      </Typography>
      <Typography className={ classes.baseText } component='div'>
        { objective.description }
      </Typography>
      <Typography className={ classes.title } component='div'>
        {t('objective.appraisers')}
      </Typography>
      <Typography className={ classes.baseText } component='div'>
        { getApprasiersOfObjective(objective) }
      </Typography>
      <Typography className={ classes.title } component='div'>
        { t('objective.average.title') }
      </Typography>
      {
        isAllRaterClosed(objective?.appraisers_and_criterias?.appraisers) ?
          <AverageOfRatesOfObjective averageOfObjectiveRates={ averageOfObjectiveRates }/> :
          <Typography className={ classes.infoBox }>
            {t('objective.average.not_available_yet')}
          </Typography>
      }
      <CriteriaEvaluationsGroupedByEmployees
        objective = { objective }
        objectiveRates = { objectiveRates }
        onSubmitSuccess = { onSubmitSuccess }
      />
    </Grid> :
    <></>
  );
};

export default ObjectiveInfo;
